import { DsAvatar } from '@frontends/ds';
import { type ClientSession } from '@/types/Auth.ts';
import { getBrowserIcon } from './sessionDevice';
import { SessionMeta } from './SessionMeta';
import { useSessionFormatters } from './useSessionFormatters';

export function SessionSummary({ session }: { session: ClientSession }) {
  const { getTitle } = useSessionFormatters();

  return (
    <div className="flex items-center gap-3 rounded-lg border border-borderPrimary px-3 py-2.5">
      <DsAvatar shape="square" icon={getBrowserIcon(session.user_agent)} aria-hidden />
      <div className="flex min-w-0 flex-col wrap-break-word">
        <span className="text-base font-medium text-textPrimary">{getTitle(session)}</span>
        <SessionMeta session={session} />
      </div>
    </div>
  );
}
